<template>
  <div class="home-index">
    <!-- 第一部分 -->
    <div class="h-i-1">
      <div class="h-1">
        <div class="h-1-1">
          您身边的
        </div>
        <div class="h-1-2">
          分布式+大数据技术服务专家
        </div>
        <div class="h-1-3">
          深入行业内部，更专业，所以更值得信赖
        </div>
        <div @click="demand" class="h-1-4">
          让 我 了 解 您 的 需 求
        </div>
      </div>
      <div class="h-2">
        In-depth inside the
        <br>
        industry more
        <br>
        professional
        <br>
        so more
        <br>
        trustworthy
      </div>
      <div @click="popups" v-if="minWidth < 500" class="h-3">
        <img src="../assets/app/cd.png" alt="">
      </div>
      <div v-if="minWidth < 500" class="h-56">
        <img src="../assets/img/footer/logo.png" alt="">
      </div>
    </div>
    <!-- 第二部分 -->
    <Strength />
    <!-- 第三部分 -->
    <Scheme />
    <!-- 第四部分 -->
    <Partner />
    <div class="h-i-5">
      <!-- <img src="../assets/img/footer/wjx.png" alt=""> -->
    </div>
    <!-- 底部 -->
    <Footer />
    <!-- 侧边栏 -->
    <aside v-if="flag == true">
      <div id="toTop" @click="headTop" class="aside-right">
        <!-- <img class="aside-1" src="../assets/img/footer/icon1.png" alt=""> -->
        <!-- <div class="aside-2"></div> -->
        <img class="aside-3" src="../assets/img/footer/icon2.png" alt="">
      </div>
    </aside>
    <van-popup
      v-model="show"
      closeable
      position="left"
      :style="{ height: '100%', width: '50%' }"
    >
      <div class="van-pop">
        <div class="pop-c">
          <img src="../assets/img/footer/logo.png" alt="">
          <div @click="vanPop1" class="content-pop">首页</div>
          <div @click="vanPop2" class="content-pop">我们的实力</div>
          <div @click="vanPop3" class="content-pop">解决方案</div>
          <div @click="vanPop4" class="content-pop">合作伙伴</div>
        </div>
      </div>
    </van-popup>
    <!-- <van-button type="primary">主要按钮</van-button> -->
  </div>
</template>

<script>
import Strength from "@/components/strength.vue"
import Scheme from "@/components/scheme.vue"
import Partner from "@/components/ner.vue"
import Footer from "@/components/footer.vue"
import Popup from "@/components/popup.vue"
export default {
  name: '',
  components: {
    Strength,
    Scheme,
    Partner,
    Footer,
    Popup
  },
  data() {
    return {
      show: false,
      tab: 1,
      tabIntroduce: [
        {
          id: 1,
          icon: require('../assets/img/home/tab1.png'),
          title: '国家资质认证',
          content: '国家高新技术企业、双软认证企业，同时拥有超20项国家知识产权及相关资质',
          width: '32px',
          height: '34px'
        },
        {
          id: 2,
          icon: require('../assets/img/home/tab2.png'),
          title: '一站式省心服务',
          content: 'APP、 公众号、 小程序、 软件系统、 营销推广、 技术运维一站式服务',
          width: '30px',
          height: '32px'
        },
        {
          id: 3,
          icon: require('../assets/img/home/tab3.png'),
          title: '技术架构能力',
          content: '超过80人实力团队，8年行业经验，千万级商业系统架构能力',
          width: '36px',
          height: '40px'
        },
        {
          id: 4,
          icon: require('../assets/img/home/tab4.png'),
          title: '严控项目流程',
          content: '每个项目分7个阶段，9个开发团队角色、9项交付成果，严控进度和代码质量',
          width: '34px',
          height: '30px'
        },
        {
          id: 5,
          icon: require('../assets/img/home/tab5.png'),
          title: '交付质量高',
          content: '敏捷开发模式，全开源代码交付，有文档、有运维保障，迭代快 ',
          width: '36px',
          height: '32px'
        }
      ],
      lance: require('../assets/img/tab/lance.jpg'),
      tabCut: 1,
      tabList: [
        {
          id: 1,
          icon: require('../assets/img/tab/lance.jpg')
        },
        {
          id: 2,
          icon: require('../assets/img/tab/t1.jpg'),
        },
        {
          id: 3,
          icon: require('../assets/img/tab/t2.jpg'),
        },
        {
          id: 4,
          icon: require('../assets/img/tab/t3.jpg'),
        },
        {
          id: 5,
          icon: require('../assets/img/tab/t4.jpg'),
        },
        {
          id: 6,
          icon: require('../assets/img/tab/t5.jpg'),
        },
        {
          id: 7,
          icon: require('../assets/img/tab/t6.jpg'),
        },
        {
          id: 8,
          icon: require('../assets/img/tab/t7.jpg'),
        },
        {
          id: 9,
          icon: require('../assets/img/tab/t8.jpg'),
        },
        {
          id: 10,
          icon: require('../assets/img/tab/t9.jpg'),
        },
        {
          id: 11,
          icon: require('../assets/img/tab/t10.jpg'),
        },
        {
          id: 12,
          icon: require('../assets/img/tab/t11.jpg'),
        },
        {
          id: 13,
          icon: require('../assets/img/tab/t12.jpg'),
        },
        {
          id: 14,
          icon: require('../assets/img/tab/t13.jpg'),
        },
        {
          id: 15,
          icon: require('../assets/img/tab/t14.jpg'),
        },
        {
          id: 16,
          icon: require('../assets/img/tab/t15.jpg'),
        }
      ],
      partnerList: [
        {
          id: 1,
          icon: require('../assets/img/cooperation/partner1.png')
        },
        {
          id: 2,
          icon: require('../assets/img/cooperation/partner2.png')
        },
        {
          id: 3,
          icon: require('../assets/img/cooperation/partner3.png')
        },
        {
          id: 4,
          icon: require('../assets/img/cooperation/partner4.png')
        },
        {
          id: 5,
          icon: require('../assets/img/cooperation/partner5.png')
        },
        {
          id: 6,
          icon: require('../assets/img/cooperation/partner6.png')
        },
        {
          id: 7,
          icon: require('../assets/img/cooperation/partner7.png')
        },
        {
          id: 8,
          icon: require('../assets/img/cooperation/partner8.png')
        },
        {
          id: 9,
          icon: require('../assets/img/cooperation/partner9.png')
        },
        {
          id: 10,
          icon: require('../assets/img/cooperation/partner10.png')
        },
        {
          id: 11,
          icon: require('../assets/img/cooperation/partner11.png')
        },
        {
          id: 12,
          icon: require('../assets/img/cooperation/partner12.png')
        },
        {
          id: 13,
          icon: require('../assets/img/cooperation/partner13.png')
        },
        {
          id: 14,
          icon: require('../assets/img/cooperation/partner14.png')
        },
        {
          id: 15,
          icon: require('../assets/img/cooperation/partner15.png')
        },
        {
          id: 16,
          icon: require('../assets/img/cooperation/partner16.png')
        },
        {
          id: 17,
          icon: require('../assets/img/cooperation/partner17.png')
        },
        {
          id: 18,
          icon: require('../assets/img/cooperation/partner18.png')
        }
      ],
      minWidth:'',
      flag: false
    }
  },
  mounted() {
    window.addEventListener('resize', this.getWidth);
    this.getWidth()

     window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    tabInclude(item) {
      this.tab = item.id
    },
    tabItemList(item) { // 软著搞起
      console.log('搞起', item)
      // this.tabCut = item.id
      this.lance = item.icon
    },
    getWidth(){
      // this.height = window.innerWidth - 70 + 'px';
      this.minWidth = String(window.innerWidth)
    },
    popups() {
      // console.log('您点击了!')
      this.show = true
    },
    handleScroll () { //改变元素#searchBar的top值
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var offsetTop = document.querySelector('#searchBar').offsetTop;
      if(scrollTop<=200){
        offsetTop = 300 - Number(scrollTop);
        document.querySelector('#searchBar').style.top = offsetTop+'px';
      }else{
        document.querySelector('#searchBar').style.top = '100px';
      }
      console.log('666', scrollTop)
      if (scrollTop.toFixed(0) > 1000) {
        this.flag = true
      }
      if (scrollTop.toFixed(0) < 1000) {
        this.flag = false
      }
    },
    headTop(i) {
      var myTimer = -1;
      var scrollTo = document.documentElement.scrollTop || document.body.scrollTop
      if(myTimer = -1){
        myTimer = setInterval(() => {
            scrollTo -= 60
            if(scrollTo<=0){
                scrollTo = 0
                window.clearInterval(myTimer)
                myTimer = -1
            }

            window.scrollTo(0,scrollTo) //这是值  是指离开网页顶部的距离
        }, 10);
      }
      // setTimeout(() => {
      //   document.documentElement.scrollTop = 0
      // }, 500);
    },
    vanPop1() {
      this.show = false
      document.documentElement.scrollTop = 0
    },
    vanPop2() {
      this.show = false
      document.documentElement.scrollTop = 200
    },
    vanPop3() {
      this.show = false
      document.documentElement.scrollTop = 1150
    },
    vanPop4() {
      this.show = false
      document.documentElement.scrollTop = 2500
    },
    demand() { // 跳转客服
      // window.open()
      KS.openChatWin()
    }
  },
}
</script>

<style lang="scss" scoped>
// @media #{$smWidth} { // 移动端适配
//   .banners-index {
//     width: 165px;
//   }
//   $desktop: '(min-width: 1200px)';
// $mdWidth: '(min-width:747px) and (max-width: 1199px)';
$smWidth: '(min-width:359px)and (max-width: 747px)';
// $xsWidth: '(max-width: 359px)';
// }

// $desktop: '(min-width: 1200px)';
// @media #{$desktop}
// @media #{'min-width: 1200px'} {

// }
// @media screen and (min-width: 1200px) {

//  }
// 修改滚动条
// 修改滚动条
::-webkit-scrollbar {
  width: 3px;
}
::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: rgba(0,0,0,0.1);
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: rgba(0,0,0,0.1);
}
  .home-index {
    width: 100%;
    height: 100%;
    @media screen and (min-width: 500px) {
      .h-i-1 {
        width: 100%;
        height: 600px;
        background: url(../assets/img/home/banner1.png) no-repeat;
        background-size: 100% 100%;
        position: relative;
        overflow-x:auto;
        .h-1 {
          display: flex;
          justify-content: center;
          flex-direction: column;
          margin: 0 auto;
          height: 100%;
          width: 50%;
          @keyframes bounceInLeft {
            from, 60%, 75%, 90%, to {animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);}
            0% {opacity: 0;transform: translate3d(-2000px, 0, 0);}
            60% {opacity: 1;transform: translate3d(25px, 0, 0);}
            75% {transform: translate3d(-10px, 0, 0);}
            90% {transform: translate3d(5px, 0, 0);}
            100% {opacity: 1;transform: none;}
          }
          @keyframes bounceInRight {
            from, 60%, 75%, 90%, to {animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);}
            0% {opacity: 0;transform: translate3d(40%, 0, 0);}
            60% {opacity: 1;transform: translate3d(-25px, 0, 0);}
            75% {transform: translate3d(10px, 0, 0);}
            90% {transform: translate3d(-5px, 0, 0);}
            100% {opacity: 1;transform: none;}
          }
          @keyframes fadeInBig{
            from{opacity: 0;transform: scale(2.5);}
            to{opacity: 1;transform: scale(1);}
          }
          .h-1-1 {
            font-size: 36px;
            font-family: PingFang SC;
            font-weight: 400;
            animation: bounceInLeft 2s 0.5s linear forwards;
            color: #FFFFFF;
          }
          .h-1-2 {
            font-size: 36px;
            font-family: PingFang SC;
            animation: bounceInRight 3s 0.5s linear forwards;
            font-weight: 400;
            color: #FFFFFF;
            margin-top: 6px;
          }
          @keyframes toShow {
            0% {opacity: 0;}
            100% {opacity: 1;}
          }
          @-webkit-keyframes toShow {
            0% {opacity: 0;}
            100% {opacity: 1;}
          }
          .h-1-3 {
            font-size: 18px;
            font-family: PingFang SC;
            position: absolute;
            animation: toShow 2s 0.5s;
            animation: toShow 2s 0.5s;
            animation-fill-mode: both !important;
            -webkit-animation-fill-mode: both !important;
            font-weight: 300;
            // color: #5489F9;
            color: #ffffff;
            margin-top: 6px;
          }
          .h-1-4 {
            width: 230px;
            height: 60px;
            background: linear-gradient(71deg, #B6359C 0%, #EF0A6A 100%);
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 100px;
            cursor: pointer;
            // animation: fadeInBig 1.5s 2s linear forwards;
            // -webkit-animation: fadeInBig 1.5s 2s linear forwards;
            animation: bounceInLeft 3s 0.5s linear forwards;
            -webkit-animation: bounceInLeft 3s 0.5s linear forwards;
          }
        }
        .h-2 {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 100;
          color: #FFFFFF;
          opacity: 0.3;
          text-align: right;
          position: absolute;
          right: 30px;
          bottom: 50px;
        }
      }
    }
    @media screen and (min-width:359px) and (max-width: 500px) {
      .h-i-1 {
        width: 100%;
        height: 210px;
        background: url(../assets/img/home/banner1.png) no-repeat;
        background-size: 100% 100%;
        position: relative;
        .h-1 {
          display: flex;
          justify-content: center;
          flex-direction: column;
          padding-left: 20px;
          position: absolute;
          bottom: 20px;
          .h-1-1 {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
          }
          .h-1-2 {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            margin-top: 3px;
          }
          .h-1-3 {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 300;
            // color: #5489F9;
            color: #ffffff;
            margin-top: 6px;
          }
          .h-1-4 {
            width: 170px;
            height: 35px;
            background: linear-gradient(71deg, #B6359C 0%, #EF0A6A 100%);
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 20px;
            cursor: pointer;
          }
        }
        .h-2 {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 100;
          color: #FFFFFF;
          opacity: 0.3;
          text-align: right;
          position: absolute;
          right: 15px;
          bottom: 10px;
        }
        .h-3 {
          position: absolute;
          right: 15px;
          top: 30px;
          img {
            width: 18px;
            height: 18px;
          }
        }
        .h-56 {
          position: absolute;
          left: 15px;
          top: 20px;
          img {
            width: 75px;
            height: 25px;
          }
        }
      }
    }
    .h-i-2 {
      width: 100%;
      padding-bottom: 50px;
      .our-strength {
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        .our-1 {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 60px;
          .our-left {
            .first-1 {
              font-size: 68px;
              font-family: Source Han Sans CN;
              font-weight: 800;
              color: #0C1364;
              opacity: 0.4;
              -webkit-text-stroke: 1px #FFFFFF;
              text-stroke: 1px #FFFFFF;
              // padding-top: 100px;
              padding-left: 15px;
            }
            .first-2 {
              font-size: 60px;
              font-family: PingFang SC;
              font-weight: 600;
              color: #FFFFFF;
              margin-top: -90px;
              z-index: 999;
              opacity: 0.9;
            }
            .first-3 {
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 300;
              color: #FFFFFF;
              opacity: 0.5;
              margin-top: 30px;
            }
            .first-4 {
              width: 210px;
              height: 72px;
              background: linear-gradient(39deg, #B6359C, #EF0A6A);
              border-radius: 36px;
              font-size: 24px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #FFFFFF;
              text-align: center;
              line-height: 72px;
              cursor: pointer;
              margin-top: 30px;
            }
          }
          .our-right {
            width: 80%;
            height: 380px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 48px;
            position: relative;
            .right-1 {
              font-size: 16px;
              font-family: Source Han Sans CN;
              font-weight: 300;
              color: #ADE9FF;
              line-height: 24px;
              opacity: 0.5;
              text-align: right;
              position: absolute;
              right: 30px;
              top: 35px;
            }
            .right-2 {
              display: flex;
              justify-content: space-between;
              // align-items: center;
              margin-top: 160px;
              .r-i {
                width: 20%;
                // background: #FFFFFF;
                // height: 200px;
                display: flex;
                justify-content: space-around;
                cursor: pointer;
                height: 260px;
                // align-items: center;
                .r-i-i {
                  display: flex;
                  align-items: center;
                  flex-direction: column;
                  // justify-content: center;
                  width: 80%;
                  .icon {
                    width: 40px;
                    height: 40px;
                    img {
                      width: 32px;
                      height: 34px;
                    }
                  }
                  .title {
                    margin-top: 24px;
                    font-size: 18px;
                    color: #ffffff;
                  }
                  .content {
                    color: #556AD5;
                    font-size: 16px;
                    text-align: center;
                    margin-top: 10px;
                  }
                }
              }
              .active {
                background: #ffffff;
                padding: 30px 0px;
                margin-top: -30px;
                border-radius: 24px;
                .r-i-i {
                  .title {
                    color: #000000;
                  }
                  .content {
                    color: #9391A6;
                  }
                }
              }
            }
          }
        }
        .our-2 {
          .out-1 {
            font-size: 68px;
            font-family: Source Han Sans CN;
            font-weight: 800;
            color: #0C1364;
            opacity: 0.4;
            -webkit-text-stroke: 1px #FFFFFF;
            text-stroke: 1px #FFFFFF;
            // padding-top: 100px;
            margin-top: 120px;
            text-align: center;
          }
          .out-2 {
            font-size: 60px;
            font-family: PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            margin-top: -90px;
            z-index: 999;
            opacity: 0.9;
            text-align: center;
          }
          .out-3 {
            text-align: center;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 300;
            color: #FFFFFF;
            opacity: 0.5;
            margin-top: 10px;
          }
          .out-4 {
            margin-top: 30px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            img {
              width: 30%;
              height: 270px;
            }
          }
          .out-5 {
            margin-top: 80px;
            display: flex;
            justify-content: space-between;
            height: 290px;
            .o-5-l {
              img {}
                width: 18%;
                height: 290px;
              }
            cursor: pointer;
            .o-5-r {
              width: 80%;
              height: 100%;
              display: flex;
              .order {
                // width: 226px;
                img {
                  width: 226px;
                  height: 290px;
                }
              }
            }
          }
        }
        .our-3 {
          margin-top: 100px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .o-3-l {
            width: 58%;
            height: 680px;
            background: url(../assets/img/home/zqq.png) no-repeat;
            background-size: 100% 100%;
            position: relative;
            .defi {
              display: flex;
              align-items: center;
              flex-direction: column;
              height: 100%;
              justify-content: center;
              margin-left: 50px;
              cursor: pointer;
              img {
                width: 130px;
                height: 90px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
            .qb {
              display: flex;
              align-items: center;
              flex-direction: column;
              position: absolute;
              top: 50px;
              left: 190px;
              cursor: pointer;
              img {
                width: 76px;
                height: 67px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
            .jy {
              display: flex;
              align-items: center;
              flex-direction: column;
              position: absolute;
              top: 0px;
              cursor: pointer;
              right: 190px;
              img {
                width: 80px;
                height: 80px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
            .dapp {
              display: flex;
              align-items: center;
              flex-direction: column;
              position: absolute;
              top: 350px;
              left: 100px;
              cursor: pointer;
              img {
                width: 80px;
                height: 80px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
            .gl {
              display: flex;
              align-items: center;
              flex-direction: column;
              position: absolute;
              top: 270px;
              cursor: pointer;
              right: 50px;
              img {
                width: 85px;
                height: 85px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
            .lh {
              display: flex;
              align-items: center;
              flex-direction: column;
              position: absolute;
              bottom: 70px;
              cursor: pointer;
              right: 200px;
              img {
                width: 97px;
                height: 97px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
          }
          .o-3-r {
            width: 40%;
            position: relative;
            .position-index {
              position: absolute;
              font-size: 180px;
              font-family: Source Han Sans CN;
              font-weight: 800;
              color: #0C1364;
              opacity: 0.3;
              right: 0px;
              top: -150px;
              -webkit-text-stroke: 1px #00CCFF;
              text-stroke: 1px #00CCFF;
            }
            .o-r-1 {
              font-size: 60px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #FFFFFF;
              opacity: 0.95;
            }
            .o-r-2 {
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 300;
              color: #FFFFFF;
              opacity: 0.5;
              margin-top: 10px;
            }
            .o-r-3 {
              width: 380px;
              height: 72px;
              background: linear-gradient(73deg, #B6359C 0%, #EF0A6A 100%);
              border-radius: 36px;
              margin-top: 60px;
              display: flex;
              align-items: center;
              justify-content: space-around;
              cursor: pointer;
              span {
                font-size: 24px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
              }
              img {
                width: 67px;
                height: 17px;
              }
            }
          }
        }
        .our-4 {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .o-3-l {
            width: 60%;
            height: 680px;
            background: url(../assets/img/home/zq.png) no-repeat;
            background-size: 100% 100%;
            position: relative;
            .defi {
              display: flex;
              align-items: center;
              flex-direction: column;
              height: 100%;
              justify-content: center;
              cursor: pointer;
              // margin-left: 50px;
              img {
                width: 85px;
                height: 69px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
            .qb {
              display: flex;
              align-items: center;
              flex-direction: column;
              cursor: pointer;
              position: absolute;
              top: 50px;
              left: 150px;
              img {
                width: 82px;
                height: 82px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
            .jy {
              display: flex;
              align-items: center;
              flex-direction: column;
              position: absolute;
              cursor: pointer;
              top: 70px;
              right: 170px;
              img {
                width: 62px;
                height: 62px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
            .dapp {
              display: flex;
              align-items: center;
              flex-direction: column;
              position: absolute;
              top: 300px;
              cursor: pointer;
              left: 20px;
              img {
                width: 64px;
                height: 62px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
            .gl {
              display: flex;
              align-items: center;
              flex-direction: column;
              cursor: pointer;
              position: absolute;
              top: 350px;
              right: 100px;
              img {
                width: 63px;
                height: 62px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
            .lh {
              display: flex;
              align-items: center;
              flex-direction: column;
              position: absolute;
              bottom: 30px;
              right: 300px;
              cursor: pointer;
              img {
                width: 72px;
                height: 72px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
          }
          .o-3-r {
            width: 40%;
            position: relative;
            .p-solution {
              position: absolute;
              position: absolute;
              font-size: 180px;
              font-family: Source Han Sans CN;
              font-weight: 800;
              color: #0C1364;
              opacity: 0.3;
              left: 0px;
              top: -150px;
              -webkit-text-stroke: 1px #00CCFF;
              text-stroke: 1px #00CCFF;
            }
            .o-r-1 {
              opacity: 0.95;
              font-size: 60px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #FFFFFF;
            }
            .o-r-2 {
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 300;
              color: #FFFFFF;
              opacity: 0.5;
              margin-top: 10px;
            }
            .o-r-3 {
              width: 380px;
              height: 72px;
              background: linear-gradient(73deg, #B6359C 0%, #EF0A6A 100%);
              border-radius: 36px;
              margin-top: 60px;
              display: flex;
              align-items: center;
              justify-content: space-around;
              cursor: pointer;
              span {
                font-size: 24px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
              }
              img {
                width: 67px;
                height: 17px;
              }
            }
          }
        }
      }
    }
    // 第三部分
    .h-i-3 {
      width: 100%;
      height: 800px;
      background: url(../assets/img/scheme/scheme.png) no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .i-3-1 {
        font-size: 46px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
      }
      .i-3-2 {
        width: 220px;
        height: 70px;
        border: 1px solid #FFFFFF;
        font-size: 36px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
        line-height: 70px;
        margin-top: 60px;
        cursor: pointer;
      }
      .i-3-3 {
        width: 1200px;
        height: 1px;
        background: #FFFFFF;
        margin-top: 90px;
      }
      .i-3-4 {
        font-size: 46px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        margin-top: 100px;
      }
      .i-3-5 {
        width: 300px;
        height: 60px;
        background: #FFFFFF;
        font-size: 32px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #033360;
        margin-top: 70px;
        text-align: center;
        line-height: 60px;;
      }
    }
    .h-i-4 {
      width: 100%;
      padding: 100px 0px 60px 0px;
      background: url(../assets/img/footer/background.png) no-repeat;
      background-size: 100% 100%;
      .i-4-c {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .i-4-1 {
          font-size: 60px;
          font-family: Source Han Sans CN;
          font-weight: 800;
          color: #141B6A;
          opacity: 0.5;
          -webkit-text-stroke: 1px #46A5FF;
          text-stroke: 1px #46A5FF;
        }
        .i-4-2 {
          font-size: 54px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          margin-top: 50px;
          opacity: 0.99;
        }
        .i-4-3 {
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 300;
          color: #FFFFFF;
          opacity: 0.5;
          margin-top: 10px;
        }
        .i-4-4 {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          width: 100%;
          .i-c-c-1 {
            // width: 33%;
            margin-top: 60px;
            img {
              width: 260px;
              height: 70px;
            }
          }
          .i-c-c-2 {
            // width: 33%;
            margin-top: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 260px;
              height: 70px;
            }
          }
          .i-c-c-3 {
            // width: 33%;
            margin-top: 60px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            img {
              width: 260px;
              height: 70px;
            }
          }
        }
        .i-4-5 {
          font-size: 50px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #FFFFFF;
          margin-top: 150px;
        }
        .i-4-6 {
          width: 300px;
          height: 70px;
          background: #FFFFFF;
          border-radius: 40px;
          text-align: center;
          line-height: 70px;
          font-size: 36px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #f11873;
          margin-top: 50px;
        }
      }
    }
    // map
    @media screen and (min-width: 500px) {
      .h-i-5 {
        width: 100%;
        height: 400px;
        background: url(../assets/img/footer/api.png) no-repeat;
        background-size: 100% 100%;
        position: relative;
        cursor: pointer;
        overflow-x:auto;
        img {
          width: 50px;
          height: 50px;
          position: absolute;
          left: 37%;

          top: 32%;
          cursor: pointer;
        }
      }
    }
    @media screen and (min-width:359px) and (max-width: 500px) {
      .h-i-5 {
        width: 100%;
        height: 150px;
        background: url(../assets/app/map.png) no-repeat;
        background-size: 100% 100%;
        position: relative;
        cursor: pointer;
        img {
          width: 13px;
          height: 13px;
          position: absolute;
          left: 37%;
          top: 32%;
          cursor: pointer;
        }
      }
    }
    // 底部
    .footer-bottom {
      width: 100%;
      padding: 120px 0px 120px 0px;
      background: #12164A;
      .footer-center {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .footer-1 {
          font-size: 32px;
          font-family: PingFang SC;
          font-weight: 100;
          color: #FFFFFF;
        }
        .footer-2 {
          width: 300px;
          height: 70px;
          background: #FFFFFF;
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #001C3A;
          text-align: center;
          line-height: 70px;
          margin-top: 30px;
          cursor: pointer;
        }
        .footer-3 {
          width: 100%;
          height: 1px;
          background: #FFFFFF;
          margin-top: 40px;
        }
        .footer-4 {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 100px;
          .f-l {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            img {
              width: 210px;
              height: 70px;
            }
            p {
              font-size: 24px;
              font-family: PingFang SC;
              font-weight: 100;
              color: #FFFFFF;
              margin-top: 20px;
            }
          }
          .f-r {
            font-size: 32px;
            font-family: PingFang SC;
            font-weight: 100;
            color: #FFFFFF;
            margin-left: 120px;
          }
        }
        .footer-5 {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 50px;
          .f-5-l {
            img {
              width: 210px;
              height: 210px;
            }
          }
          .f-5-r {
            margin-left: 120px;
            .f-1 {
              font-size: 20px;
              font-family: PingFang SC;
              font-weight: 100;
              color: #FFFFFF;
              opacity: 0.5;
              display: flex;
              .f-1-2 {
                width: 300px;
              }
            }
            .f-2 {
              font-size: 20px;
              font-family: PingFang SC;
              font-weight: 100;
              color: #FFFFFF;
              opacity: 0.5;
              margin-top: 50px;
              display: flex;
              align-items: center;
              .f-2-1 {

              }
              .f-2-2 {
                width: 26px;
                height: 28px;
                margin-left: 20px;
                cursor: pointer;
              }
              .f-2-3 {
                width: 29px;
                height: 24px;
                margin-left: 20px;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
    @media screen and (min-width: 500px) {
      .aside-right {
        position: fixed;
        z-index: 1000;
        overflow-x:auto;
        bottom: 10%;
        right: 0;
        width: 80px;
        height: 90px;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 12px 0px 0px 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        cursor: pointer;
        .aside-1 {
          width: 46px;
          height: 52px;
        }
        .aside-2 {
          width: 60%;
          height: 2px;
          background: #0C1364;
          margin-top: 20px;
        }
        .aside-3 {
          width: 36px;
          height: 49px;
          // margin-top: 20px;
        }
      }
    }
    @media screen and (min-width:359px) and (max-width: 500px) {
      .aside-right {
        position: fixed;
        z-index: 1000;
        bottom: 10%;
        right: 0;
        width: 45px;
        height: 45px;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 12px 0px 0px 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        cursor: pointer;
        .aside-1 {
          width: 25px;
          height: 28px;
        }
        .aside-2 {
          width: 60%;
          height: 1px;
          background: #0C1364;
          margin-top: 10px;
        }
        .aside-3 {
          width: 18px;
          height: 24px;
          // margin-top: 10px;
        }
      }
    }
  }
.van-pop {
  width: 100%;
  height: 100%;
  background: rgba(18, 22, 74, 0.79);
  .pop-c {
    padding-top: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    img {
      width: 137px;
      height: 47px;
    }
    .content-pop {
      color: #ffffff;
      font-size: 20px;
      margin-top: 30px;
    }
  }
}
</style>
